import { PlusIcon as PlusIconSolid } from "@heroicons/react/solid";

import { handleTrackingButtonOnClick } from "./index";

export default function NoBorderButtonWithPlusIcon({ text, onClick }: any) {
  return (
    <div
      style={{ color: "#18A0FB" }}
      className="flex cursor-pointer items-center justify-center"
      onClick={() => handleTrackingButtonOnClick(text, onClick)}
    >
      <button
        style={{
          background: "transparent",
          color: "#18A0FB",
          border: "1px solid #18A0FB",
        }}
        type="button"
        className="inline-flex items-center rounded-full border border-transparent bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-700"
      >
        <PlusIconSolid className="h-5 w-5" aria-hidden="true" />
      </button>
      <label className="ml-3 cursor-pointer">{text}</label>
    </div>
  );
}
